import { useQuery } from 'react-query';

import { getGenericQuery } from '../../../utils/neurons';
import { BASE_MAPPING_URL } from '../constants';

const useMappedGames = ({ slug, isDisabled }) => useQuery([`${BASE_MAPPING_URL}${slug}/`], getGenericQuery, {
    enabled: !!slug && !isDisabled,
    retry: 0,
    refetchOnWindowFocus: false,
});

export default useMappedGames;
